import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import UsersService, { BOAPI } from "../service/UsersService";

// value חייב להתאים בדיוק ל-CK_Users_role/spBOSetUserRole ב-SQL
// ('customer' | 'owner' | 'admin') - לא 'user'
const ROLES = [
  { value: 'customer', label: 'לקוח' },
  { value: 'owner', label: 'בעל עסק' },
  { value: 'admin', label: 'מנהל' },
];

const UserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activities, setActivities] = useState([]);
  const [roleBusy, setRoleBusy] = useState(false);
  const [roleError, setRoleError] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [deleteBusy, setDeleteBusy] = useState(false);
  const [deleteError, setDeleteError] = useState('');

  useEffect(() => {
    const loadUser = async () => {
      let foundUser = UsersService.users?.find(u => u.id === Number(id));

      if (!foundUser) {
        const resp = await BOAPI.fetchUsers();
        foundUser = resp?.[1]?.find(u => u.id === Number(id));
      }

      setUser(foundUser);

      try {
        const res = await BOAPI.fetchUserActivities(id);
        if (res?.[0]?.[0]?.code === 0) {
          setActivities(res[1] || []);
        }
      } catch (err) {
        console.error("Error fetching activities:", err);
      }
    };

    loadUser();
  }, [id]);

  const changeRole = async (newRole) => {
    setRoleBusy(true);
    setRoleError('');
    try {
      const resp = await BOAPI.setUserRole(user.id, newRole);
      if (resp?.[0]?.[0]?.code === 0) {
        setUser((u) => ({ ...u, role: newRole }));
        UsersService.users = UsersService.users?.map((u) => (u.id === user.id ? { ...u, role: newRole } : u));
      } else {
        setRoleError(resp?.[0]?.[0]?.msg || 'עדכון התפקיד נכשל');
      }
    } catch {
      setRoleError('שגיאה בתקשורת עם השרת');
    } finally {
      setRoleBusy(false);
    }
  };

  // מחיקה קשיחה (spBODeleteUser) - חסומה בשרת אם למשתמש יש היסטוריית עסקאות/
  // בעלות על בית עסק/הצעת בית עסק (ראו הערה ב-BO.sql) - השגיאה במקרה כזה
  // מוצגת כאן כדי שיהיה ברור למה המחיקה לא בוצעה
  const confirmDelete = async () => {
    setDeleteBusy(true);
    setDeleteError('');
    try {
      const resp = await BOAPI.deleteUser(user.id);
      if (resp?.[0]?.[0]?.code === 0) {
        UsersService.removeUser(user.id);
        navigate(-1);
      } else {
        setDeleteError(resp?.[0]?.[0]?.msg || 'המחיקה נכשלה');
      }
    } catch {
      setDeleteError('שגיאה בתקשורת עם השרת');
    } finally {
      setDeleteBusy(false);
    }
  };

  // פונקציית עזר לחלוקת הפעילויות לפי ימים
  const groupActivitiesByDay = (items) => {
    const groups = {};

    items.forEach(act => {
      if (!act.iTime) return;

      // תחלץ רק את חלק התאריך (10 התווים הראשונים: YYYY-MM-DD)
      const dateString = act.iTime.substring(0, 10);
      const [year, month, day] = dateString.split('-');

      // צור תאריך בלי להיכנס לבעיות של טיימזון
      const dateObj = new Date(year, month - 1, day);

      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      let dayLabel = dateObj.toLocaleDateString("he-IL", { day: "numeric", month: "long", year: "numeric" });

      if (dateObj.toDateString() === today.toDateString()) {
        dayLabel = "היום";
      } else if (dateObj.toDateString() === yesterday.toDateString()) {
        dayLabel = "אתמול";
      }

      if (!groups[dayLabel]) {
        groups[dayLabel] = [];
      }
      groups[dayLabel].push(act);
    });

    return groups;
  };

  if (!user) {
    return <div style={styles.center}>טוען...</div>;
  }

  const groupedActivities = groupActivitiesByDay(activities);

  return (
    <div style={styles.page}>

      <button style={styles.backBtn} onClick={() => navigate(-1)}>
        ← חזרה
      </button>

      {/* כרטיס פרופיל */}
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.avatar}>
            {user.fName?.[0]}{user.lName?.[0]}
          </div>
          <div>
            <h2 style={styles.name}>
              {user.fName} {user.lName}
            </h2>
            <p style={styles.username}>{user.phone}</p>
          </div>
        </div>

        <div style={styles.grid}>
          <Info label="ID" value={user.id} />
          <Info label="אימייל" value={user.email || "-"} />
          <Info label="טלפון" value={user.phone || "-"} />
          <Info label="סטטוס" value={user.isActive ? "פעיל" : "לא פעיל"} />
          <Info label="תאריך הרשמה" value={user.iTime ? new Date(user.iTime).toLocaleDateString("he-IL") : "-"} />
        </div>

        <div style={styles.roleBox}>
          <span style={styles.label}>תפקיד</span>
          <div style={styles.roleRow}>
            {ROLES.map((r) => (
              <button
                key={r.value}
                style={{ ...styles.roleBtn, ...(user.role === r.value ? styles.roleBtnActive : {}) }}
                onClick={() => changeRole(r.value)}
                disabled={roleBusy || user.role === r.value}
              >
                {r.label}
              </button>
            ))}
          </div>
          {roleError && <div style={styles.roleError}>❌ {roleError}</div>}
        </div>

        <div style={styles.dangerBox}>
          <button style={styles.deleteBtn} onClick={() => setDeleting(true)}>🗑️ מחיקת משתמש לצמיתות</button>
        </div>
      </div>

      {deleting && (
        <div style={styles.overlay} onClick={() => !deleteBusy && setDeleting(false)}>
          <div style={styles.deleteModalCard} onClick={(e) => e.stopPropagation()}>
            <h3 style={styles.deleteModalTitle}>מחיקת משתמש לצמיתות</h3>
            <p style={styles.deleteModalText}>
              למחוק את <strong>"{user.fName} {user.lName}" ({user.phone})</strong> לצמיתות מהמערכת?
              הפעולה לא ניתנת לביטול. אם יש למשתמש היסטוריית עסקאות או בעלות על בית עסק/הצעת בית עסק,
              המחיקה תיחסם - אפשר להשבית אותו במקום.
            </p>
            {deleteError && <div style={styles.roleError}>❌ {deleteError}</div>}
            <div style={styles.modalActions}>
              <button style={styles.cancelBtn} onClick={() => setDeleting(false)} disabled={deleteBusy}>ביטול</button>
              <button style={styles.confirmDeleteBtn} onClick={confirmDelete} disabled={deleteBusy}>
                {deleteBusy ? 'מוחק...' : 'מחיקה לצמיתות'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* אזור פעילויות מעוצב ומחולק לפי ימים (30 הימים האחרונים - ראו spBOGetUserActivities) */}
      <div style={{ ...styles.card, marginTop: "2rem" }}>
        <h3 style={{ marginBottom: "2rem", color: "#1a1f36", fontSize: "18px" }}>ציר זמן פעילות</h3>

        {Object.keys(groupedActivities).length === 0 ? (
          <div style={{ color: "#888", fontSize: "14px", textAlign: "center", padding: "1rem" }}>
            אין פעילויות להצגה בחודש האחרון.
          </div>
        ) : (
          <div>
            {Object.entries(groupedActivities).map(([day, dayActs]) => (
              <div key={day} style={{ marginBottom: "1.5rem" }}>
                {/* כותרת היום */}
                <div style={styles.dayHeader}>{day}</div>

                <div style={styles.timeline}>
                  {dayActs.map((act, index) => (
                    <div key={act.id || index} style={styles.timelineItem}>

                      {/* קו הנחש האנכי */}
                      <div style={styles.timelineLine} />

                      {/* נקודת המפגש של הנחש */}
                      <div style={styles.timelineBadge} />

                      {/* תיבת התוכן */}
                      <div style={styles.timelineContent}>
                        <div style={styles.contentHeader}>
                          <span style={styles.timelineText}>
                            {act.eventDescription || act.eventName}
                          </span>
                          <span style={styles.timelineTime}>
                            {(act.iTime || '').substring(11, 16)}
                          </span>
                        </div>

                        {act.eventName && act.eventDescription && (
                          <div style={styles.activityCode}>{act.eventName}</div>
                        )}
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

    </div>
  );
};

const Info = ({ label, value }) => (
  <div style={styles.infoBox}>
    <div style={styles.label}>{label}</div>
    <div style={styles.value}>{value}</div>
  </div>
);

const styles = {
  page: {
    padding: "2rem",
    background: "#f6f8fb",
    minHeight: "100vh",
    direction: "rtl"
  },

  backBtn: {
    marginBottom: "1rem",
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    background: "white",
    cursor: "pointer"
  },

  card: {
    background: "white",
    borderRadius: "16px",
    padding: "2rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.03)"
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginBottom: "2rem"
  },

  avatar: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "#1f6feb",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "bold"
  },

  name: {
    margin: 0
  },

  username: {
    margin: 0,
    color: "#666"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1rem"
  },

  infoBox: {
    background: "#f9fafc",
    padding: "1rem",
    borderRadius: "12px",
    border: "1px solid #eee"
  },

  label: {
    fontSize: "12px",
    color: "#888",
    marginBottom: "6px"
  },

  value: {
    fontSize: "14px",
    fontWeight: "600"
  },

  roleBox: {
    marginTop: "1.5rem",
    paddingTop: "1.5rem",
    borderTop: "1px solid #eee",
  },

  roleRow: {
    display: "flex",
    gap: "8px",
    marginTop: "8px",
  },

  roleBtn: {
    padding: "8px 16px",
    borderRadius: "10px",
    border: "1.5px solid #e3e8ee",
    background: "#fff",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 700,
    color: "#697386",
  },

  roleBtnActive: {
    background: "#1f6feb",
    borderColor: "#1f6feb",
    color: "#fff",
  },

  roleError: {
    marginTop: "8px",
    fontSize: "12px",
    color: "#c62828",
    fontWeight: 600,
  },

  dangerBox: {
    marginTop: "1.5rem",
    paddingTop: "1.5rem",
    borderTop: "1px solid #eee",
  },

  deleteBtn: {
    padding: "10px 18px",
    borderRadius: "10px",
    border: "1px solid #c62828",
    background: "#fff",
    color: "#c62828",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 700,
  },

  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    padding: 16,
    direction: "rtl",
  },

  deleteModalCard: {
    width: "100%",
    maxWidth: 420,
    background: "#fff",
    borderRadius: 20,
    boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
    padding: 24,
  },

  deleteModalTitle: {
    margin: "0 0 14px",
    fontSize: 17,
    fontWeight: 800,
    color: "#c62828",
  },

  deleteModalText: {
    fontSize: "13.5px",
    color: "#4f566b",
    lineHeight: 1.6,
    marginBottom: 18,
  },

  modalActions: {
    display: "flex",
    gap: 10,
  },

  cancelBtn: {
    flex: 1,
    padding: "11px 16px",
    background: "#fff",
    color: "#4f566b",
    border: "1.5px solid #e3e8ee",
    borderRadius: 10,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 700,
  },

  confirmDeleteBtn: {
    flex: 1,
    padding: "11px 16px",
    background: "#c62828",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 700,
  },

  center: {
    padding: "2rem",
    textAlign: "center"
  },

  dayHeader: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#4f566b",
    background: "#f1f3f9",
    padding: "4px 12px",
    borderRadius: "20px",
    display: "inline-block",
    marginBottom: "1rem",
    boxShadow: "0 1px 3px rgba(0,0,0,0.02)"
  },

  timeline: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    paddingRight: "15px",
  },

  timelineItem: {
    display: "flex",
    position: "relative",
    paddingBottom: "1.2rem",
    alignItems: "flex-start",
  },

  timelineLine: {
    position: "absolute",
    right: "4px",
    top: "10px",
    bottom: 0,
    width: "2px",
    background: "#e3e8ee",
  },

  timelineBadge: {
    position: "absolute",
    right: "0px",
    top: "8px",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "#1f6feb",
    border: "2px solid white",
    boxShadow: "0 0 0 2px rgba(31, 111, 235, 0.2)",
    zIndex: 1,
  },

  timelineContent: {
    marginRight: "25px",
    background: "#fff",
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid #e3e8ee",
    width: "100%",
    boxShadow: "0 2px 5px rgba(0,0,0,0.01)",
    transition: "transform 0.2s ease"
  },

  contentHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px"
  },

  timelineText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1a1f36",
  },

  timelineTime: {
    fontSize: "12px",
    color: "#a3acb9",
    fontWeight: "500"
  },

  activityCode: {
    fontSize: "12px",
    color: "#697386",
    marginTop: "2px"
  },
};

export default UserDetails;
